import _toConsumableArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _uniq from "lodash/uniq";
import _range from "lodash/range";
import _isNil from "lodash/isNil";
import _fromPairs from "lodash/fromPairs";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.map.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import FastqFileType from 'const/enums/FastqFileType';
import naturalCompareWords from 'utils/naturalCompareWords';
var WT_FASTQ = FastqFileType.WT_FASTQ,
  IMMUNE_FASTQ = FastqFileType.IMMUNE_FASTQ;
var getEmptySublibrarySelections = function getEmptySublibrarySelections() {
  return _defineProperty(_defineProperty({}, WT_FASTQ, {}), IMMUNE_FASTQ, {});
};
var laneRegex = /_L\d{1,4}/;
var getSublibraryKeyFromPairName = function getSublibraryKeyFromPairName(pairName) {
  return pairName.replace(laneRegex, '');
};
var getAutoDetectedSublibrarySelections = function getAutoDetectedSublibrarySelections(pairs, filesData, sublibraries, numOfSublibraries) {
  var pairedWt = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var sublibrarySelections = getEmptySublibrarySelections();
  var sublibraryIdToPosition = _fromPairs((sublibraries !== null && sublibraries !== void 0 ? sublibraries : []).map(function (_ref2) {
    var id = _ref2.id,
      position = _ref2.position;
    return [id, position];
  }));
  [WT_FASTQ, IMMUNE_FASTQ].forEach(function (type) {
    // In paired WT runs, skip filename detection for immune files
    // Sequencer sample numbers (e.g. S1/S2) reflect lane/run labels, not WT-to-immune pairing.
    var skipFilenameDetection = pairedWt && type === IMMUNE_FASTQ;
    var pairsWithPersistedPosition = {};
    var pairNameToKey = {};
    Object.entries(pairs[type]).forEach(function (_ref3) {
      var _pairFiles$find;
      var _ref4 = _slicedToArray(_ref3, 2),
        pairName = _ref4[0],
        fileIds = _ref4[1];
      var pairFiles = fileIds.map(function (id) {
        return filesData[id];
      }).filter(Boolean);
      var persistedSublibraryId = (_pairFiles$find = pairFiles.find(function (f) {
        return !_isNil(f.sublibraryId);
      })) === null || _pairFiles$find === void 0 ? void 0 : _pairFiles$find.sublibraryId;
      var persistedPosition = sublibraryIdToPosition[persistedSublibraryId];
      if (!_isNil(persistedPosition)) {
        pairsWithPersistedPosition[pairName] = persistedPosition;
        return;
      }
      if (skipFilenameDetection) return;
      pairNameToKey[pairName] = getSublibraryKeyFromPairName(pairName);
    });
    Object.assign(sublibrarySelections[type], pairsWithPersistedPosition);
    if (skipFilenameDetection) return;
    var persistedKeyToPosition = {};
    Object.entries(pairsWithPersistedPosition).forEach(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        pairName = _ref6[0],
        position = _ref6[1];
      persistedKeyToPosition[getSublibraryKeyFromPairName(pairName)] = position;
    });
    var newKeys = [];
    Object.entries(pairNameToKey).forEach(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
        pairName = _ref8[0],
        key = _ref8[1];
      var inheritedPosition = persistedKeyToPosition[key];
      if (!_isNil(inheritedPosition)) {
        sublibrarySelections[type][pairName] = inheritedPosition;
      } else {
        newKeys.push(key);
      }
    });

    // Assign new pairKeys to remaining available positions in natural-sort order.
    var usedPositions = new Set(Object.values(sublibrarySelections[type]));
    var availablePositions = _range(1, numOfSublibraries + 1).filter(function (pos) {
      return !usedPositions.has(pos);
    });
    var keyToPosition = _fromPairs(_uniq(newKeys).sort(function (a, b) {
      return naturalCompareWords(a, b);
    }).slice(0, availablePositions.length).map(function (key, i) {
      return [key, availablePositions[i]];
    }));
    Object.entries(pairNameToKey).forEach(function (_ref9) {
      var _ref0 = _slicedToArray(_ref9, 2),
        pairName = _ref0[0],
        key = _ref0[1];
      if (!_isNil(sublibrarySelections[type][pairName])) return;
      var position = keyToPosition[key];
      if (!_isNil(position)) {
        sublibrarySelections[type][pairName] = position;
      }
    });
  });
  return sublibrarySelections;
};

// Iterates over the union of pair names across both selection maps,
// calling fn(type, pairName, selectionsAForType, selectionsBForType).
var forEachTypeAndPairName = function forEachTypeAndPairName(selectionsA, selectionsB, fn) {
  [WT_FASTQ, IMMUNE_FASTQ].forEach(function (type) {
    var pairNames = _uniq([].concat(_toConsumableArray(Object.keys(selectionsA[type])), _toConsumableArray(Object.keys(selectionsB[type]))));
    pairNames.forEach(function (pairName) {
      return fn(type, pairName, selectionsA[type], selectionsB[type]);
    });
  });
};

// Merges auto-detected and user selections
// User selection wins when present, otherwise falls back to auto-detected.
var getMergedSublibrarySelections = function getMergedSublibrarySelections(autoDetectedSublibrarySelections, sublibraryUserSelections) {
  var mergedSublibrarySelections = getEmptySublibrarySelections();
  forEachTypeAndPairName(autoDetectedSublibrarySelections, sublibraryUserSelections, function (type, pairName, autoDetectedForType, userSelectionsForType) {
    var selection = Object.prototype.hasOwnProperty.call(userSelectionsForType, pairName) ? userSelectionsForType[pairName] : autoDetectedForType[pairName];
    if (!_isNil(selection)) {
      mergedSublibrarySelections[type][pairName] = selection;
    }
  });
  return mergedSublibrarySelections;
};

// Computes the delta between current selections and auto-detected
// Only stores pairs where the user explicitly overrides or unassigns.
var getPairsMatchesUserSelections = function getPairsMatchesUserSelections(autoDetectedSublibrarySelections, currentSublibrarySelections) {
  var sublibraryUserSelections = getEmptySublibrarySelections();
  forEachTypeAndPairName(autoDetectedSublibrarySelections, currentSublibrarySelections, function (type, pairName, autoDetectedForType, currentForType) {
    var autoDetectedSelection = autoDetectedForType[pairName];
    if (Object.prototype.hasOwnProperty.call(currentForType, pairName)) {
      var currentSelection = currentForType[pairName];
      if (currentSelection !== autoDetectedSelection) {
        sublibraryUserSelections[type][pairName] = currentSelection;
      }
      return;
    }
    if (!_isNil(autoDetectedSelection)) {
      sublibraryUserSelections[type][pairName] = null;
    }
  });
  return sublibraryUserSelections;
};
var getSelectedPairNamesForRow = function getSelectedPairNamesForRow(sublibrarySelectionsForType, rowPosition) {
  return Object.keys(sublibrarySelectionsForType).filter(function (pairName) {
    return sublibrarySelectionsForType[pairName] === rowPosition;
  });
};
var hasMultiplePairsPerSublibrary = function hasMultiplePairsPerSublibrary(pairsForType, numOfSublibraries) {
  if (_isNil(numOfSublibraries)) return false;
  if (Object.keys(pairsForType).length > numOfSublibraries) return true;
  var pairCountByKey = {};
  return Object.keys(pairsForType).some(function (pairName) {
    var _pairCountByKey$key;
    var key = getSublibraryKeyFromPairName(pairName);
    pairCountByKey[key] = ((_pairCountByKey$key = pairCountByKey[key]) !== null && _pairCountByKey$key !== void 0 ? _pairCountByKey$key : 0) + 1;
    return pairCountByKey[key] > 1;
  });
};
var buildSublibraryPayload = function buildSublibraryPayload(sublibrarySelections, pairs, sublibraries) {
  var positionToSublibraryId = _fromPairs(sublibraries.map(function (_ref1) {
    var id = _ref1.id,
      position = _ref1.position;
    return [position, id];
  }));
  var assignmentsBySublibraryId = new Map();
  var addFileIdsToAssignment = function addFileIdsToAssignment(sublibraryId, fileIds) {
    var _assignmentsBySublibr, _existingAssignment$f;
    var assignmentKey = _isNil(sublibraryId) ? 'null' : sublibraryId;
    var existingAssignment = (_assignmentsBySublibr = assignmentsBySublibraryId.get(assignmentKey)) !== null && _assignmentsBySublibr !== void 0 ? _assignmentsBySublibr : {
      sublibraryId: sublibraryId,
      fileIds: []
    };
    (_existingAssignment$f = existingAssignment.fileIds).push.apply(_existingAssignment$f, _toConsumableArray(fileIds));
    assignmentsBySublibraryId.set(assignmentKey, existingAssignment);
  };
  [WT_FASTQ, IMMUNE_FASTQ].forEach(function (type) {
    Object.entries(pairs[type]).forEach(function (_ref10) {
      var _ref11 = _slicedToArray(_ref10, 2),
        pairName = _ref11[0],
        fileIds = _ref11[1];
      var rowPosition = sublibrarySelections[type][pairName];
      var sublibraryId = _isNil(rowPosition) ? null : positionToSublibraryId[rowPosition];
      addFileIdsToAssignment(sublibraryId, fileIds);
    });
  });
  return Array.from(assignmentsBySublibraryId.values()).map(function (_ref12) {
    var sublibraryId = _ref12.sublibraryId,
      fileIds = _ref12.fileIds;
    return {
      sublibraryId: sublibraryId,
      fileIds: fileIds
    };
  });
};
var hasUnsavedSublibraryChanges = function hasUnsavedSublibraryChanges(sublibrarySelections, pairs, sublibraries, filesData) {
  var sublibraryPayload = buildSublibraryPayload(sublibrarySelections, pairs, sublibraries);
  return sublibraryPayload.some(function (_ref13) {
    var sublibraryId = _ref13.sublibraryId,
      fileIds = _ref13.fileIds;
    return fileIds.some(function (fileId) {
      var _filesData$fileId;
      return ((_filesData$fileId = filesData[fileId]) === null || _filesData$fileId === void 0 ? void 0 : _filesData$fileId.sublibraryId) !== sublibraryId;
    });
  });
};
var getMatcherIsNeeded = function getMatcherIsNeeded(pairedWt, wtFileCount, immuneFileCount, numOfSublibraries) {
  var pairs = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  if (pairedWt) return true;
  var hasExtraFastqFiles = wtFileCount > numOfSublibraries * 2 || immuneFileCount > numOfSublibraries * 2;
  if (_isNil(pairs)) {
    return hasExtraFastqFiles;
  }
  return hasMultiplePairsPerSublibrary(pairs[WT_FASTQ], numOfSublibraries) || hasMultiplePairsPerSublibrary(pairs[IMMUNE_FASTQ], numOfSublibraries);
};
var getMatcherAreValid = function getMatcherAreValid(_ref14) {
  var _pairs$WT_FASTQ, _pairs$IMMUNE_FASTQ;
  var matcherIsNeeded = _ref14.matcherIsNeeded,
    sublibrarySelections = _ref14.sublibrarySelections,
    pairs = _ref14.pairs,
    numOfSublibraries = _ref14.numOfSublibraries,
    wtRequired = _ref14.wtRequired,
    immuneRequired = _ref14.immuneRequired;
  if (_isNil(pairs) || _isNil(numOfSublibraries)) return false;
  var wtPairNames = Object.keys((_pairs$WT_FASTQ = pairs[WT_FASTQ]) !== null && _pairs$WT_FASTQ !== void 0 ? _pairs$WT_FASTQ : {});
  var immunePairNames = Object.keys((_pairs$IMMUNE_FASTQ = pairs[IMMUNE_FASTQ]) !== null && _pairs$IMMUNE_FASTQ !== void 0 ? _pairs$IMMUNE_FASTQ : {});
  if (wtRequired && wtPairNames.length < numOfSublibraries) return false;
  if (immuneRequired && immunePairNames.length < numOfSublibraries) return false;
  if (!matcherIsNeeded) {
    return true;
  }
  var wtSelections = sublibrarySelections[WT_FASTQ];
  var immuneSelections = sublibrarySelections[IMMUNE_FASTQ];
  var everyPairAssigned = function everyPairAssigned(pairNames, selectionsForType) {
    return pairNames.every(function (pairName) {
      return !_isNil(selectionsForType[pairName]);
    });
  };
  var everyRowAssigned = function everyRowAssigned(selectionsForType) {
    return _range(1, numOfSublibraries + 1).every(function (rowPosition) {
      return getSelectedPairNamesForRow(selectionsForType, rowPosition).length > 0;
    });
  };
  var wtValid = !wtRequired || everyPairAssigned(wtPairNames, wtSelections) && everyRowAssigned(wtSelections);
  var immuneValid = !immuneRequired || everyPairAssigned(immunePairNames, immuneSelections) && everyRowAssigned(immuneSelections);
  return wtValid && immuneValid;
};
export { buildSublibraryPayload, getEmptySublibrarySelections, getAutoDetectedSublibrarySelections, getPairsMatchesUserSelections, getMergedSublibrarySelections, hasUnsavedSublibraryChanges, hasMultiplePairsPerSublibrary, getSelectedPairNamesForRow, getMatcherAreValid, getMatcherIsNeeded };